import { errorTostHandler } from "helper/ErrorTostHandler";
import {
  GET_ORDER_DETAILS,
  GET_SHIPMENT_TIME_LINE,
  GET_SHIP_BOB_ORDER,
  LIST_SUBSCRIPTION,
  REACTIVATE_SUBSCRIPTION,
  UPDATE_SUBSCRIPTION_STATUS,
  USER_SUBSCRIPTION_DETAILS,
} from "helper/url_helper";
import { toast } from "react-toastify";
import { axiosAccount, axiosAdmin } from "services/api";
import {
  CANCEL_SUBSCRIPTION_LOADING,
  FETCH_SUBSCRIPTION_DATA,
  FETCH_SUBSCRIPTION_DATA_ERROR,
  FETCH_SUBSCRIPTION_DATA_LOADING,
  GET_ORDER_DATA,
  GET_ORDER_DATA_LOADING,
  GET_SHIPBOB_ORDER,
  GET_SHIPBOB_ORDER_LOADING,
  GET_SHIPMENT_TIME_LINE_DATA,
  GET_SHIPMENT_TIME_LINE_LOADING,
  GET_SUBSCRIPTION,
  GET_SUBSCRIPTION_LOADING,
  REACTIVE_SUBSCRIPTION_LOADING,
} from "./actionTypes";

export const handleFetchSubscriptionData = payload => {
  return async dispatch => {
    try {
      dispatch(fetchSubscriptionDataLoading(true));
      const res = await axiosAccount.post(LIST_SUBSCRIPTION, payload);
      if (res?.data) {
        dispatch(fetchSubscriptionData(res?.data?.data));
        dispatch(fetchSubscriptionDataLoading(false));
      }
    } catch (err) {
      dispatch(fetchSubscriptionDataLoading(false));
      dispatch({ type: FETCH_SUBSCRIPTION_DATA_ERROR, payload: null });
      errorTostHandler(err, 20);
    }
  };
};

export const getUserSubscriptionData = payload => {
  return async dispatch => {
    try {
      dispatch({ type: GET_SUBSCRIPTION_LOADING, payload: true });
      const res = await axiosAccount.get(
        USER_SUBSCRIPTION_DETAILS + "/" + payload
      );
      if (res?.data) {
        dispatch({
          type: GET_SUBSCRIPTION,
          payload: res?.data?.data?.SubscriptionDetail,
        });
        dispatch({ type: GET_SUBSCRIPTION_LOADING, payload: false });
      }
    } catch (err) {
      dispatch({ type: GET_SUBSCRIPTION_LOADING, payload: false });
      errorTostHandler(err, 21);
    }
  };
};

export const reactivateSubscription = (data, cb) => async dispatch => {
  try {
    dispatch({ type: REACTIVE_SUBSCRIPTION_LOADING, payload: true });
    const res = await axiosAccount.post(REACTIVATE_SUBSCRIPTION, data);
    if (res.status) {
      toast.success("Subscription reactivated successfully.");

      dispatch({ type: REACTIVE_SUBSCRIPTION_LOADING, payload: false });
      if (!!cb && typeof cb === "function") cb(res?.data);
    }
  } catch (err) {
    errorTostHandler(err, 22);
    dispatch({ type: REACTIVE_SUBSCRIPTION_LOADING, payload: false });
  }
};

export const updateSubscription = (data, cb) => async dispatch => {
  try {
    dispatch({ type: CANCEL_SUBSCRIPTION_LOADING, payload: true });
    const res = await axiosAccount.post(UPDATE_SUBSCRIPTION_STATUS, data);
    if (res.status) {
      dispatch({ type: CANCEL_SUBSCRIPTION_LOADING, payload: false });
      if (!!cb && typeof cb === "function") cb(res?.data);
    }
  } catch (err) {
    errorTostHandler(err, 23);
    dispatch({ type: CANCEL_SUBSCRIPTION_LOADING, payload: false });
  }
};

export const getOrderData = data => async dispatch => {
  try {
    dispatch({ type: GET_ORDER_DATA_LOADING, payload: true });
    const res = await axiosAccount.post(GET_ORDER_DETAILS, data);
    if (res.status) {
      dispatch({
        type: GET_ORDER_DATA,
        payload: res?.data?.data?.orderDetails,
      });
      dispatch({ type: GET_ORDER_DATA_LOADING, payload: false });
    }
  } catch (err) {
    errorTostHandler(err, 24);
    dispatch({ type: GET_ORDER_DATA_LOADING, payload: false });
  }
};

export const getShipBobOrder = data => async dispatch => {
  try {
    dispatch({ type: GET_SHIPBOB_ORDER_LOADING, payload: true });
    const res = await axiosAdmin.post(GET_SHIP_BOB_ORDER, data);
    if (res.status) {
      dispatch({
        type: GET_SHIPBOB_ORDER,
        payload: res?.data?.data?.rows || [],
      });
      dispatch({ type: GET_SHIPBOB_ORDER_LOADING, payload: false });
    }
  } catch (err) {
    errorTostHandler(err, 25);
    dispatch({ type: GET_SHIPBOB_ORDER_LOADING, payload: false });
  }
};

export const getShipTimeLine = data => async dispatch => {
  try {
    dispatch({ type: GET_SHIPMENT_TIME_LINE_LOADING, payload: true });
    const res = await axiosAdmin.post(GET_SHIPMENT_TIME_LINE, data);
    if (res.status) {
      dispatch({
        type: GET_SHIPMENT_TIME_LINE_DATA,
        payload: res?.data?.data,
      });
      dispatch({ type: GET_SHIPMENT_TIME_LINE_LOADING, payload: false });
    }
  } catch (err) {
    errorTostHandler(err, 26);
    dispatch({ type: GET_SHIPMENT_TIME_LINE_LOADING, payload: false });
  }
};

export const fetchSubscriptionDataLoading = data => ({
  type: FETCH_SUBSCRIPTION_DATA_LOADING,
  payload: data,
});

export const fetchSubscriptionData = data => ({
  type: FETCH_SUBSCRIPTION_DATA,
  payload: data,
});
